export function exhaustiveCheck(_: never): void {
  // intentionally empty
}

export function exhaustiveCheckFail(value: never): never {
  throw new Error(`Exhaustive check failed. Case for value "${String(value)}" was not handled.`);
}
